import { useTranslation } from "react-i18next";
import { Box, Button, Chip, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Stack, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";
import { useState } from "react";
import { useMission } from "../../../../providers/MissionProvider";
import ResponsiveDialog from "../../../common/core/ResponsiveDialog";
import { FullTimeView } from "../../../common/core/Time";
import { GetMissionRequestResponseChipStyle } from "../../../../common/missionrequests";
import { MissionRequestEnumLists, MissionRequestEnums } from "../../../../common/constants";
import MissionRequestDialog from "../../missionrequests/missionrequest/MissionRequestDialog";

const useStyles = makeStyles()(
  (theme) => ({
    titleContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    closeButton: {
      marginLeft: theme.spacing(-1),
      marginRight: theme.spacing(1)
    },
    listItem: {
      width: "100%",
      position: "relative",
      "&:hover": {
        "&:after": {
          zIndex: 1000,
          position: "absolute",
          height: "100%",
          width: "100%",
          top: 0,
          left: 0,
          background: theme.palette.action.hover,
          borderRadius: "8px",
          content: "''",
          display: "block",
          pointerEvents: "none"
        },
      }
    },
    responseStateChip: {
      borderRadius: theme.spacing(1)
    }
  })
);

export default function SentMissionRequestsDialog(props) {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { onClose, missionRequests } = props;
  const { mission } = useMission(); // TODO
  const [selectedRequestId, setSelectedRequestId] = useState(null);

  return (
    <ResponsiveDialog
      open
      onClose={onClose}
      fullWidth
      maxWidth={"sm"}
    >
      <DialogTitle className={classes.titleContainer}>

        {t("mission:sentRequestsDialog:title")}

        <IconButton onClick={onClose} size="small" color="primary" className={classes.closeButton}>
          <CloseIcon />
        </IconButton>

      </DialogTitle>

      <DialogContent>
        <Stack>
          {missionRequests.map((request, key) => (
            <Box key={key} className={classes.listItem} onClick={() => setSelectedRequestId(request.id)}>
              <Stack spacing={1} sx={{ padding: 1 }}>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="subtitle1">{mission?.sentRequests.find(t => t.id === request.id)?.name || "-"}</Typography>
                  <Chip label={t(`missionRequests:enums:responseState:${MissionRequestEnumLists.ResponseState[request.response || 0]}`)} style={GetMissionRequestResponseChipStyle(request.response)} className={classes.responseStateChip} />
                </Stack>

                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body2" color="textSecondary">{request.message || "-"}</Typography>
                  <Typography variant="body2" color="textSecondary"><FullTimeView isDate time={request.response === MissionRequestEnums.ResponseState.New ? request.created : request.responded} /></Typography>
                </Stack>
              </Stack>

              <Divider sx={{ marginTop: 1 }} />
            </Box>
          ))}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          {t("common:close")}
        </Button>
      </DialogActions>

      {!!selectedRequestId ? (
        <MissionRequestDialog entityId={selectedRequestId} onClose={() => setSelectedRequestId(null)} sent />
      ) : null}

    </ResponsiveDialog>
  );
}




